<template>
<div class="prdListWrap">
    <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore"  distance-index.number="1" bottom-distance.number="200">
        <!--我的订单页面-->
        <div class="container">
              <div class="orderBox boxSizing" v-for="item in myorderList">
                  <!--<router-link class="myorderTop clearfix" :to="{path:'/orderDel',query:{id:item.id}}">-->
                  <div class="myorderTop clearfix" @click="toOrderDel(item)">
                      <div class="myorderFl fl">
                          <img :src="item.goods_cover" class="orderCover">
                          <div class="mask" v-text="maskState[item.status]">11111</div>
                      </div>
                      <div class="myorderDel">
                          <div class="myorderName oneEllipsis" v-text="item.goods_name"></div>
                          <div class="clearfix">
                            <p class="myoPrice fl">￥<span v-text="item.goods_price"></span></p>
                            <p class="myoNum fr">数量：x<span v-text="item.goods_num"></span></p>
                          </div>
                      </div>
                  </div>
                  <!--</router-link>-->
                  <div class="myoSum">
                      <p class="fl">共<span v-text="item.goods_num"></span>件商品 实付款： ¥ <span v-text="item.money"></span></p>
                      <!--立即付款  再次购买  交易取消-->
                      <p class="orderState fr" v-text="btnState[item.status]" :class="item.status === 0 ? 'paynow' : 'commonState'" @click="orderBtn(item)"></p>
                  </div>
              </div>
        </div>
    </mt-loadmore>
    <!--无数据时展示-->
    <div v-if="noDataOrder" class="noDataOrder">您还没有相关订单，快去购买吧！</div>
</div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import common from "../common";
import { MessageBox } from "mint-ui";
import { Loadmore } from 'mint-ui';

export default {
  name: "myOrder",
  data() {
    return {
      pageIndex:1,
      pageSize:4,
      allLoaded:false,
      myorderList: [],
      //订单遮罩状态
      maskState: {
        0: "未付款",
        1: "待发货",
        2: "已发货",
        3: "已取消",
        4: "已收货"
      },
      //订单按钮状态
      btnState: {
        0: "立即付款",
        1: "再次购买",
        2: "再次购买",
        3: "交易关闭",
        4: "再次购买"
      },
      iswx: '',
      iswxpc: '',
      noDataOrder: true,  //是否有数据
      ifloadmore: true    //判断是否是由数据上拉加载导致的data = 0
    };
  },
    //   watch:{
    //     '$route' (to, from) {
    //       this.$router.go(0);
    //     }
    // },
    created() {
        common.iflogin();
        let IsOS = navigator.userAgent.toLowerCase();
        this.iswx = IsOS.indexOf("micromessenger") > -1;
        this.iswxpc = IsOS.indexOf("windowswechat") > -1;
    },
  mounted() {
    this.getMyorder(this.ifloadmore);
  },
  methods: {
    //下拉列表
    loadBottom(){
        var that = this;
        that.getMyorder(()=>{
          that.$refs.loadmore.onBottomLoaded();
        });
    },
    //获取订单列表
    getMyorder(callback,ifloadmore) {
      axios.post("/wap/orderHandle/orderList",qs.stringify({ page: this.pageIndex, limit:this.pageSize }))
        .then((data) => {
            console.log(data);
            var data = data.data.data;
            if(data.length === 0){
                this.allLoaded = true;//加载
            }else{
                this.pageIndex +=1;
                this.noDataOrder = false; //没数据，提示信息
            }

            for (var i = 0; i < data.length; i++) {
                this.myorderList.push(data[i]);
            }

            callback && (typeof(callback) === "function") && callback();
        }).catch(error => {
            console.log(error);
        });
    },
    //立即付款  再次购买  交易关闭按钮
    orderBtn: function (item) {
       console.log(item);
      //item是循环遍历的每一个订单详情
      var status = item.status;
      var url = item.payment_key;
      var goods_id = item.goods_id;
      //商品信息存到内存
      localStorage.setItem("bookCover", item.goods_cover);
      localStorage.setItem("booktit", item.goods_name);
      localStorage.setItem("bookPrice", item.goods_price);
      localStorage.setItem("id", item.id);//orderId
      //立即付款
      if (status === 0) {
          //判断微信内支付  微信外支付
          // if (url.indexOf("[prepay_id]") != -1) {
          //order_agent = 4 代表 微信支付——来源公众号端
          if (item.order_agent == 4) {
              this.$WxJsapiPay('/wap/WxpayFor/JSAPI_ContinuePay',{prepay_id:url},(res)=>{
                 this.$router.push({path:'/orderDel',query:{id:item.id}});
                  return res;
              },(err)=>{
                  localStorage.removeItem('ifwxpay');
                  this.Toast({ message: err.msg, position: "center", duration: 2000 });
              })
          }else if(item.order_agent == 3){
              //order_agent = 3 代表 微信支付——来源h5浏览器端
              //存储ifwxpay,解决谷歌不跳转直接刷新
              localStorage.setItem('ifwxpay',true);
              //解决ios浏览器跳到首页重定向
              localStorage.setItem("IsPayStatuCodeByH5", "1");
              var path = window.location.href;
              localStorage.setItem("RedirectPath",path);
              this.showMsgBox();
              location.href = url;
          }else{
              //其他端支付生成的订单全部提示信息
              this.Toast({
                  message: "请到下单处进行支付！",
                  position: "center",
                  duration: 2000
              });
          }
      } else if (status === 3) {
        //交易关闭
        this.Toast({
          message: "交易已关闭",
          position: "center",
          duration: 2000
        });
      } else {
        //再次购买
        this.$router.push({ path: "/editOrder", query: { id: goods_id } });
      }
    },
      showMsgBox:function () {
          //为了回调订单状态的改变所写的弹框
          var _this = this;
          if(localStorage.getItem('ifwxpay')){
              setTimeout(function () {
                  MessageBox.confirm('是否已支付完成？', {
                      title: "提示",
                      confirmButtonClass: 'confirmButton',
                      cancelButtonClass: 'cancelButton',
                  })
                      .then((data) => {
                          if(data == 'confirm'){
                              localStorage.removeItem('ifwxpay');
                              localStorage.removeItem('IsPayStatuCodeByH5');
                              //_this.$router.go(0);
                              var orderId = localStorage.getItem("id");
                              _this.$router.push({path: '/orderDel',query: {id: orderId}});
                          }
                      })
                      ["catch"]((err) => {
                          if(err == 'cancel'){
                              localStorage.removeItem('ifwxpay');
                              localStorage.removeItem('IsPayStatuCodeByH5');
                          }
                          return false;
                      });
              }, 2000);
        }
      },
      //点击跳转详情页
      toOrderDel:function(item){
        sessionStorage.setItem("scrollTop", '100');
        this.$router.push({path: "/orderDel",query: {id:item.id}});
      }
  },

};
</script>

<style scoped lang="scss">
.prdListWrap{
     -webkit-overflow-scrolling: touch;
     height:100vh;
    overflow: scroll;
    .noDataOrder{
        height: 600px;
        line-height: 600px;
        text-align: center;
        font-size: 30px;
    }
}

/deep/ .mint-loadmore-text{
    font-size: 30px;
}
.orderBox {
  font-size: 24px;
}
.myorderTop {
  display: block;
  padding: 30px 30px 20px;
  border-bottom: 1PX solid #e1e1e1;
  .orderCover {
    width: 100%;
    border: 1PX solid #dcdcdc;
  }
  .myorderName {
    font-size: 28px;
    margin: 40px 0 50px;
  }
  .myoPrice {
    color: #d63c32;
    font-size: 32px;
    font-weight: bold;
  }
  .myoNum {
    color: #999;
  }
}
.myorderFl {
  position: relative;
  width: 200px;
  height: 200px;
  margin-right: 20px;
  .mask {
    position: absolute;
    bottom: -1PX;
    width: 201px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: rgba(244, 242, 234, 0.7);
    color: #a67a42;
  }
}
.myoSum {
  height: 90px;
  line-height: 90px;
  padding: 0 30px;
  border-bottom: 20px solid #f6f7f8;
  color: #666;
  .orderState {
    width: 130px;
    height: 50px;
    margin-top: 20px;
    text-align: center;
    line-height: 50px;
    color: #fff;
    border-radius: 30px;
  }
  .commonState {
    background: linear-gradient(to bottom, #ff880d, #ffc752);
  }
  .paynow {
    background: linear-gradient(to bottom, #c59961, #e8c9a0);
  }
}
</style>
